import { ApiService } from './../api.service';
import { Component, OnInit } from '@angular/core';
import { MyUtility } from '../comparison';

@Component({
  selector: 'app-report-summary',
  templateUrl: './report-summary.component.html',
  styleUrls: ['./report-summary.component.css']
})
export class ReportSummaryComponent implements OnInit {
  criteriaName: string;

  constructor(public api: ApiService) { }

  ngOnInit() {
  }

  getName(x) {
    return x.name;
  }

  get criteria() {
    return this.api.session.currentCriteria;
  }

  get mdrText() {
    if (!this.criteria.breakpoints.multiDrugResistantIsolatesOnly) {
      return "-";
    }

    return this.criteria.breakpoints.mdrLevel;
  }

  private getCustomDisplayText(key) {
    let custom = this.criteria.customCriteria[key];
    if (MyUtility.isNothing(custom) || MyUtility.isNothing(custom.selectedItems) || custom.selectedItems.length < 1) {
      return "ALL";
    }

    return custom.selectedItems.map(x => x.name).join(", ");
  }

  public customParameters(): any[] {
    // let handle = x => this.getCustomDisplayText(x); // This is because 'this' can't be reached from within the 'map' function below

    // return this.api.session.menuList
    //   .filter(x => x.IsCustom === true)
    //   .map(function (x) {
    //     return { key: x.DisplayText, value: handle(x.Key) };
    //   });

    let retval = [];
    for (let i = 0; i < this.api.session.menuList.length; i++) {
      let menuItem = this.api.session.menuList[i];
      if (!menuItem.IsCustom) {
        continue;
      }

      let key = menuItem.Key;
      let custom = this.criteria.customCriteria[key];
      if (MyUtility.isNothing(custom)) {
        continue;
      }

      let displayText = "ALL";
      if (!MyUtility.isNothing(custom) && !MyUtility.isNothing(custom.selectedItems) && custom.selectedItems.length > 0) {
        displayText = custom.selectedItems.map(x => x.name).join(", ");
      }

      let item = {
        key: menuItem.DisplayText,
        value: displayText,
        isGrouped: this.isGrouped(custom.groupName),
        groupName: custom.groupName
      };
      retval.push(item);
    }
    return retval;
  }

  public isGrouped(groupName: string) {
    return groupName != null && groupName.length > 0;
  }

  public saveCriteria() {
    this.api.session.currentCriteria.userView = this.api.session.selectedUserView;
    let request = this.api.saveCriteria(this.api.session.currentCriteria, this.criteriaName);
    request.successFunc = data => {
      this.api.session.savedCriteria = data;
      this.criteriaName = "";
    };
    request.start();

    //this.savedCriterias.push({id:null,name:this.criteriaName});
  }

  get parametricText() {
    if (!this.criteria.parametricFilters || this.criteria.parametricFilters.length < 1)
      return "NONE";
    return this.criteria.parametricFilters.map(x => x.filterText).join(", ");
  }

  // "patientDemographics": {
  //   "male": true,
  //   "female": true,
  //   "ageFrom": 1,
  //   "ageTo": 21,
  //   "groupName": null,
  //   "IsSet": false
  // },
  get genders() {
    let array = [];
    if (this.criteria.patientDemographics.male)
      array.push("Male");
    if (this.criteria.patientDemographics.female)
      array.push("Female");

    return array;
  }

  get ageText() {
    let lowAge = this.criteria.patientDemographics.ageFrom;
    let highAge = this.criteria.patientDemographics.ageTo;

    if (!lowAge && !highAge)
      return "ALL";

    if (!lowAge && lowAge !== 0)
      lowAge = "ANY";
    if (!highAge)
      highAge = "ANY";

    return `${lowAge} to ${highAge}`;
  }

  get dateText() {
    if (this.criteria.dates.isDateRange) {
      let start = this.criteria.dates.dateStart;
      let end = this.criteria.dates.dateEnd;

      if (!start && !end)
        return "ALL";

      if (!start)
        start = "ANY";

      if (!end)
        end = "ANY"

      return MyUtility.formatDate(start) + " to " + MyUtility.formatDate(end);
    }

    let years = this.criteria.dates.selectedYears;
    if (!years || years.length < 1)
      return "ALL";

    years = years.map(x => x.name).sort((a, b) => a - b);

    return years.join(", ");
  }

  get adjustmentsText() {
    if (!this.criteria.breakpoints.adjustments || this.criteria.breakpoints.adjustments.length < 1)
      return "NONE";
    return this.criteria.breakpoints.adjustments.join(", ");
  }

  get molecularSummary() {
    let molCrit = this.criteria.MolecularCriteria;
    if (!this.criteria || !molCrit || !molCrit.Groups || molCrit.Groups.length <= 0)
      return "ALL";

    console.log("BINDING MOLECULAR -----------------")
    if (molCrit.Groups.length == 1)
      return this.getGroupSummary(molCrit.Groups[0]);

    return (molCrit.MatchAllGroups ? "ALL" : "ANY") + " of these groups: (" + molCrit.Groups.map(x => this.getGroupSummary(x)).join("), (") + ")";
  }

  getGroupSummary(group) {
    console.log("group", group);
    if (!group || !group.MolecularCriterias || group.MolecularCriterias.length < 1)
      return "EMPTY";

    if (group.MolecularCriterias.length == 1)
      return this.getCritSummary(group.MolecularCriterias[0]);

    return (group.MatchAll ? "ALL" : "ANY") + " of [" + group.MolecularCriterias.map(x => this.getCritSummary(x)).join(", ") + "]";
  }

  getCritSummary(crit) {
    console.log("crit", crit);
    if (!crit || !crit.Test)
      return "-";

    let subs = "";
    if (crit.IsPositive === true)
      subs += " POS";
    else if (crit.IsPositive === false)
      subs += " NEG";
    else if (crit.IsPositive === null && crit.TestResults && crit.TestResults.length > 0) {
      if (crit.TestResults.length > 1)
        subs += " {" + crit.TestResults.join(", ") + "}";
      else
        subs += " " + crit.TestResults[0];
    }

    return (crit.IsNot ? "NOT " : "") + crit.Test.name + subs;
  }
}
